import { apiService } from '@/services/api.service';
import { canManageUsers } from '@/utils/roleHelpers';

export default {
  namespaced: true,
  state: {
    userModules: [],
    isLoading: false,
    error: null,
  },
  getters: {
    getUserModules: (state: any) => state.userModules,
    isLoading: (state: any) => state.isLoading,
    getError: (state: any) => state.error,
  },
  mutations: {
    SET_LOADING(state: any, isLoading: boolean) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state: any, error: string | null) {
      state.error = error;
    },
    SET_USER_MODULES(state: any, modules: any[]) {
      state.userModules = modules;
    },
  },
  actions: {
    async fetchUserModules({ commit, rootState }: any, userId: string) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const modules = await apiService.getUserModules(userId);
        const currentUser = rootState?.auth?.user;
        const userCanManageUsers = canManageUsers(currentUser);
        
        // 📅 Agregar módulo de Calendario temporalmente (para desarrollo)
        // TODO: Este módulo debería venir del backend
        const manualModules = [
          {
            id: 'home-temp',
            name: 'Inicio',
            description: 'Panel principal',
            icon: 'mdi-home',
            route: '/dashboard',
            position: 0,
            isActive: true,
          },
          {
            id: 'events-temp',
            name: 'Eventos',
            description: 'Gestión de eventos de atletismo',
            icon: 'mdi-calendar-star',
            route: '/dashboard/events',
            position: 10,
            isActive: true,
          },
          {
            id: 'tests-temp',
            name: 'Pruebas',
            description: 'Gestión de pruebas por evento',
            icon: 'mdi-run-fast',
            route: '/dashboard/events/test',
            position: 11,
            isActive: true,
          },
          {
            id: 'calendar-temp',
            name: 'Calendario',
            description: 'Gestión de actividades del calendario',
            icon: 'mdi-calendar-month',
            route: '/dashboard/calendar',
            position: 999,
            isActive: true,
          },
          {
            id: 'national-records-temp',
            name: 'Records',
            description: 'Carga oficial de récords nacionales',
            icon: 'mdi-podium-gold',
            route: '/dashboard/national-records',
            position: 1000,
            isActive: true,
          },
          {
            id: 'rankings-temp',
            name: 'Rankings',
            description: 'Rankings nacionales por año, categoría y género',
            icon: 'mdi-podium',
            route: '/dashboard/rankings',
            position: 1001,
            isActive: true,
          },
        ];

        if (userCanManageUsers) {
          manualModules.push({
            id: 'users-temp',
            name: 'Usuarios',
            description: 'Administración de usuarios, roles y permisos',
            icon: 'mdi-account-group',
            route: '/dashboard/users',
            position: 1001,
            isActive: true,
          });
          manualModules.push({
            id: 'maintenance-temp',
            name: 'Mantenimiento',
            description: 'Catálogos del sistema: pruebas, categorías, géneros, estadios, ubigeo',
            icon: 'mdi-wrench',
            route: '/dashboard/maintenance',
            position: 1002,
            isActive: true,
          });
        }
        
        // Transformar las rutas de los módulos para que sean rutas completas
        const transformedModules = modules.map((m: any) => {
          let route = m.route;
          
          // Mapear rutas especiales
          if (route === '/tests') {
            route = '/events/test';
          }
          
          // Si la ruta no comienza con /dashboard, agregarle el prefijo
          if (route && !route.startsWith('/dashboard')) {
            return {
              ...m,
              route: `/dashboard${route.startsWith('/') ? route : '/' + route}`
            };
          }
          return m;
        });
        
        const modulesWithManual = [...transformedModules];

        manualModules.forEach((manualModule) => {
          const alreadyExists = modulesWithManual.some((m: any) =>
            m.route === manualModule.route || m.name === manualModule.name
          );

          if (!alreadyExists) {
            modulesWithManual.push(manualModule);
          }
        });
        
        const sanitizedModules = modulesWithManual.filter((module: any) => {
          if (!userCanManageUsers && module.route === '/dashboard/users') {
            return false;
          }
          return true;
        });

        // Ordenar los módulos por la propiedad "position" de forma ascendente
        const sortedModules = sanitizedModules.sort((a: any, b: any) => a.position - b.position);
        commit('SET_USER_MODULES', sortedModules);
      } catch (error: any) {
        console.error('Error al obtener los módulos del usuario:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error al obtener los módulos del usuario';
        commit('SET_ERROR', errorMessage);
        throw new Error(errorMessage);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Limpiar errores
    clearError({ commit }: any) {
      commit('SET_ERROR', null);
    },
  },
};